import { Navigate } from 'react-router-dom'
import { useAuthContext } from '../../contexts/AuthProvider'

export const GuestGuard = ({ children }) => {
	const { isAuthenticated } = useAuthContext()
	return isAuthenticated ? <Navigate to='/' /> : children
}
